const LANDING_SESSION_KEY = 'ae_landing_sid'
const LANDING_ANON_KEY = 'ae_landing_aid'

const parseJsonSafe = async (response) => {
  try {
    return await response.json()
  } catch {
    return null
  }
}

const request = async (url, body) => {
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(body)
  })

  const payload = await parseJsonSafe(response)
  if (!response.ok) {
    const message = payload?.message || `HTTP ${response.status}`
    throw new Error(message)
  }

  return payload
}

export const getStoredSessionId = () => {
  try {
    return localStorage.getItem(LANDING_SESSION_KEY) || ''
  } catch {
    return ''
  }
}

export const setStoredSessionId = (sessionId) => {
  if (!sessionId) return

  try {
    localStorage.setItem(LANDING_SESSION_KEY, sessionId)
  } catch {
    // ignore storage failures
  }
}

export const getOrCreateAnonymousId = () => {
  try {
    const existing = localStorage.getItem(LANDING_ANON_KEY)
    if (existing) return existing

    const generated = crypto?.randomUUID ? crypto.randomUUID() : `anon-${Date.now()}`
    localStorage.setItem(LANDING_ANON_KEY, generated)
    return generated
  } catch {
    return `anon-${Date.now()}`
  }
}

export const registerLandingVisit = async (payload) => {
  const response = await request('/api/landing/visit', payload)
  if (response?.sessionId) {
    setStoredSessionId(response.sessionId)
  }
  return response
}

export const registerLandingEvent = async (payload) => {
  return request('/api/landing/event', payload)
}
